import { render, staticRenderFns } from "./funds-tab.vue?vue&type=template&id=c32fa168&scoped=true&lang=html&"
import script from "./funds-tab.vue?vue&type=script&lang=js&"
export * from "./funds-tab.vue?vue&type=script&lang=js&"
import style0 from "./funds-tab.vue?vue&type=style&index=0&id=c32fa168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32fa168",
  null
  
)

export default component.exports